import { render } from "./MaterialSupportCabinetsTable.vue?vue&type=template&id=c62d5cbe&scoped=true"
import script from "./MaterialSupportCabinetsTable.vue?vue&type=script&lang=js"
export * from "./MaterialSupportCabinetsTable.vue?vue&type=script&lang=js"

import "./MaterialSupportCabinetsTable.vue?vue&type=style&index=0&id=c62d5cbe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c62d5cbe"]])

export default __exports__